import { createHomologationItemGuard } from '@/entities/Document';

import { APPROVAL_ITEM_MESSAGES } from '../config/messages';

/** Keeps an item already decided by someone else from opening its approval screen. */
export const approvalItemGuard = createHomologationItemGuard({
  stage: 'approval',
  listPath: '/aprovacao',
  messages: APPROVAL_ITEM_MESSAGES,
});
